import {StockScreenerService} from "./StockScreenerService";
import {StrategyBuilderService} from "./StrategyBuilderService";
import {StrategyColumnService} from "./column-def/StrategyColumnService";

export default angular.module("tfApp.strategy-builder.services", [])
                      .service(StockScreenerService.id, StockScreenerService)
                      .service(StrategyBuilderService.id, StrategyBuilderService)
                      .service(StrategyColumnService.id, StrategyColumnService)
                      .name;
